<template>
  <div>
    <Navbar />
      <div class="owner-body">
        <div class="sidebar">
            <Sidebar />
        </div>
        <div class="page">
          <div v-if="isLoading">
            <Loading />
          </div>
          <div v-else>
            <card-component>
                <div class="logs">
                    <div class="logs-heading">
                        <h3>Logs</h3>
                    </div>
                    <div class="filter">
                        <b-datepicker
                              placeholder="Type or select a date..."
                              icon="calendar-today"
                              editable>
                        </b-datepicker>
                        <p>To</p>
                        <b-datepicker
                              placeholder="Type or select a date..."
                              icon="calendar-today"
                              editable>
                          </b-datepicker>
                          <b-button class="filter-button">Filter</b-button>
                    </div>
                    <div class="roles-table">
                      <!-- <b-table :data="logData" :columns="columns"></b-table> -->
                      <b-table
                        :data="logData"
                        :paginated="isPaginated"
                        :per-page="perPage"
                        :current-page.sync="currentPage"
                        :pagination-simple="isPaginationSimple"
                        :pagination-position="paginationPosition"
                        :default-sort-direction="defaultSortDirection"
                        :pagination-rounded="isPaginationRounded"
                        :sort-icon="sortIcon"
                        :sort-icon-size="sortIconSize"
                        aria-next-label="Next page"
                        aria-previous-label="Previous page"
                        aria-page-label="Page"
                        aria-current-label="Current page"
                      >
                        <b-table-column field="name" label="NAME" v-slot="props">
                            {{ props.row.name}}
                        </b-table-column>
                        <b-table-column field="address" label="LOCATION" v-slot="props">
                            {{ props.row.address }}
                        </b-table-column>
                        <b-table-column field="created_at" label="Login Time" v-slot="props">
                            {{ props.row.date }}
                        </b-table-column>
                      </b-table>
                    </div>
                </div>
            </card-component>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Navbar from '@/components/NavBar.vue';
import Sidebar from '@/components/OwnerSidebar.vue';
import CardComponent from '@/components/CardComponent.vue';
import Loading from '@/components/Loading.vue';

import moment from 'moment';

export default {
  name: 'Logs',
  components: {
    Navbar,
    Sidebar,
    CardComponent,
    Loading
  },
  data() {
    // const loggg = this.logData;
    return {
      // loggg
      isLoading: false,
      logData: [],
      isPaginated: true,
      isPaginationSimple: false,
      isPaginationRounded: false,
      paginationPosition: 'bottom',
      defaultSortDirection: 'asc',
      sortIcon: 'arrow-up',
      sortIconSize: 'is-small',
      currentPage: null,
      perPage: 10
    };
  },
  mounted() {
    this.logData = this.formatData(this.log.log);
    this.currentPage = this.log.currentPage;
  },
  created() {
    const data = {
      company_id: this.getLoggedUser.company_id
    };
    this.fetchLogs(data);
  },
  computed: {
    ...mapGetters(['getLoggedUser', 'getStatus']),
    ...mapGetters('apps', {
      log: 'getLogs'
    })
  },
  watch: {
    'logData.created_at': {
      immediate: true,
      handler(val) {
        if (val) {
          moment(val).format('MM/DD/YYY');
        }
      }
    },
    getStatus(val) {
      if (val === 'loading') {
        this.isLoading = true;
      } else if (val === 'success') {
        this.isLoading = false;
      }
    }
  },
  methods: {
    ...mapActions('apps', ['fetchLogs']),
    formatData(data) {
      if (data) {
        return data.map((el) => {
          const obj = {};
          obj.name = el.name;
          obj.address = el.address;
          obj.date = moment(el.created_at).format('LLL');
          // console.log(obj);
          return obj;
        });
      }
    }
  }
};
</script>

<style>
.owner-body {
    padding-top: 100px;
    padding-right: 150px;
    padding-left: 150px;
    display: grid;
    grid-template-columns: 0.5fr 2fr;
}
.page {
  margin-top: 80px;
}
.th-wrap {
  color: #817F7F;
}
</style>

<style lang="scss" scoped>
.logs-heading h3 {
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 28px;
    color: #736F6F;
    margin-bottom: 27px;
}
.logs-heading {
    border-bottom: 1px solid #C4C4C4;
}
.filter {
    /* margin: 24px 0 24px auto; */
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 20px 0;
    p {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 14px;
      color: #000000;
      margin: 0 20px;
    }
    .filter-button {
      background: #3887F6;
      box-shadow: 0px 0px 13px rgba(0, 0, 0, 0.15);
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 18px;
      color: #FFFFFF;
      margin-left: 30px;
    }
}
// tr {
//   border-bottom: 2px solid black;
// }
</style>
